import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { dendrosApi } from "@/lib/dendrosDemo";
import { DendrosSidebar } from "@/components/dendros-pulse/DendrosSidebar";

export default function PopupView() {
    const [params] = useSearchParams();
    const [accountId, setAccountId] = useState(params.get("account") || null);
    const [accounts, setAccounts] = useState([]);

    useEffect(() => {
        dendrosApi.listAccounts().then((list) => {
            setAccounts(list);
            if (!accountId && list.length > 0) setAccountId(list[0].id);
        });
    }, [accountId]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-black p-4">
            <div
                className="w-[400px] h-[640px] border border-white/10 shadow-2xl flex flex-col bg-[#050505] overflow-hidden"
                data-testid="popup-frame"
            >
                <div className="px-3 py-2 border-b border-white/10 bg-zinc-950 flex items-center gap-2">
                    <span className="font-mono text-[9px] uppercase tracking-widest text-zinc-500">Account:</span>
                    <select
                        value={accountId || ""}
                        onChange={(e) => setAccountId(e.target.value)}
                        className="flex-1 bg-black border border-white/10 text-white font-mono text-[11px] px-2 py-1 outline-none focus:border-[#10b981] rounded-md"
                        data-testid="popup-account-select"
                    >
                        {accounts.map((a) => (
                            <option key={a.id} value={a.id}>
                                {a.name}
                            </option>
                        ))}
                    </select>
                </div>
                {accountId && <DendrosSidebar accountId={accountId} compact />}
            </div>
        </div>
    );
}
